import { render } from "./famousCourseHumanityVideo.vue?vue&type=template&id=07f042fa&scoped=true"
import script from "./famousCourseHumanityVideo.vue?vue&type=script&lang=js"
export * from "./famousCourseHumanityVideo.vue?vue&type=script&lang=js"

import "./famousCourseHumanityVideo.vue?vue&type=style&index=0&id=07f042fa&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f042fa"]])

export default __exports__